<template>
  <div v-bem>
    <div class="row">
      <div class="col-md-3">{{ label }}:</div>
      <div class="col-md-9">
        <!-- eslint-disable-next-line vue/no-v-html-->
        <strong v-bem:item="{ checked }" v-html="value" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummaryRow',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';
@use "sass:map";

.summary-row {
  line-height: 1.2;

  & + & {
    margin-top: utils.f-convert-to-rem(32);
  }

  @at-root #{&}__item {
    @at-root #{&}--checked {
      display: block;
      padding-left: utils.f-rem-calc(24);
      background-image: url('./images/check.svg');
      background-repeat: no-repeat;
      background-position: left center;
    }
  }
}
</style>
